import * as Raven from 'raven-js';

const dsn = 'https://741926116ea348a99be5c3de292a9801@sentry.io/217694';
const options: Raven.RavenOptions = {
  whitelistUrls: [
    /dictaphone\.audio/,
  ],
};

export const logger = Raven.config(dsn, options).install();



// WEBPACK FOOTER //
// ./src/app/logger.ts